import { REGIONS, type AppLocales } from '@constants/i18n'
import type { CountryCodes } from '@constants/countryDetails'

export const getISOCountryFromLocale = (locale?: AppLocales) => {
  const country = locale?.substring(3) as CountryCodes
  const { iso3CountryCode = null } = REGIONS[country]

  return { iso3CountryCode }
}
